<template>
  <list-item
    :booking="booking"
    :link="{ name: 'vetting.show', params: { id: booking.id } }"
  >
    <template v-slot:categories>
       <div v-if="bookingOpportunityName" class="list-item__category">
        <span class="label label-info">{{ bookingOpportunityName }}</span>
      </div>
    </template>

    <template v-slot:status>
      <div class="spacer-b-2" v-if="booking.urgent" >
        <span class="label label-danger">Urgent</span>
      </div>
    </template>

    <template v-slot:hero v-if="userCanSeeBudget" >
      {{ bookingGrandTotalBudget | currency(booking.local_currency ? booking.local_currency : booking.currency) | nullable }}
    </template>

    <template v-slot:admin>
      <div class="spacer-b-1 flex flex-row" v-if="booking.local_currency">
        <i class="fa fa-info-circle spacer-r-1"></i>
        <span>Estimated conversion to {{ booking.local_currency }}. Actual amount may differ due to fluctuating conversion rates.</span>
      </div>
    </template>
  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'
export default {
  mixins: [helpers],
  components: {
    ListItem
  },
  props: {
    booking: {
      required: true,
      type: Object
    }
  }
}
</script>
